import { IonIcon, IonLabel } from '@ionic/react'
import { bulb } from 'ionicons/icons'
import { IonChip } from './styled'

export function CancellationInProgressWarning() {
  return (
    <IonChip color='warning'>
      <IonIcon icon={bulb}></IonIcon>
      <IonLabel>Бронь автомобиля отменится в течение нескольких минут</IonLabel>
    </IonChip>
  )
}
